<template>
  <vs-popup class=""
            id="popup"
            title="QA REJECT FORMULATIONS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="comment" name="comment" rules="required" v-slot="{ errors }">
                <small class="label">Comment</small>
                <vs-textarea class="mb-0" v-model="form.comment" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end">
            <vs-button color="danger" button="submit" class="ml-auto mt-2">Reject</vs-button>
            <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const FormulationsRepository = RepositoryFactory.get('formulations')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {},
    }
  }

export default {
  name: 'QaRejectFormulationPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true
      } catch (error) {
        this.$vs.loading.close()
      }
    },

    async onClickUpdate () {
      const vue = this;
      try {
        this.$vs.loading();
        await FormulationsRepository.qaRejectFormulations(this.id, this.form)
        this.showSuccessMessage('The selected formulation was successfully qa rejected');
        await vue.$parent.refreshData()
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
